// extracted by mini-css-extract-plugin
export default {"component":"Z1FfI","heading":"eOyqZ","scale":"r5TIB","appendScale":"ZoD5c","notEnoughText":"dTDf0"};